import React from 'react';
import './CSSSquare.css';

export default () => {
  return (
    <div className="CSSSquare">
      <div className="CSSSquare__Cube CSSSquare__1" />
      <div className="CSSSquare__Cube CSSSquare__2" />
      <div className="CSSSquare__Cube CSSSquare__3" />
      <div className="CSSSquare__Cube CSSSquare__4" />
      <div className="CSSSquare__Cube CSSSquare__5" />
      <div className="CSSSquare__Cube CSSSquare__6" />
      <div className="CSSSquare__Cube CSSSquare__7" />
      <div className="CSSSquare__Cube CSSSquare__8" />
      <div className="CSSSquare__Cube CSSSquare__9" />
    </div>
  );
};
